import { useAlert } from '../../context/alert'
import SuccessAlert from './SuccessAlert'
import ErrorAlert from './ErrorAlert'

const AlertCommon = () => {
  const { showSuccess, successTitle, successDuration, handleSuccessClose, showError, errorTitle, errorMessage, handleErrorClose } =
    useAlert()
  return (
    <>
      <SuccessAlert title={successTitle} show={showSuccess} handleClose={handleSuccessClose} autoHideDuration={successDuration} />
      <ErrorAlert title={errorTitle} show={showError} message={errorMessage} handleClose={handleErrorClose} />
    </>
  )
}

export default AlertCommon
